export const baseUrlVisioncine = "https://www.visioncine.biz";
